import React from 'react';

import { useAuth } from '@fastlessjs/backoffice-layer/dist/hooks';
import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Typography } from 'antd';

import { AddReturnLine } from './AddReturnLine';
import { t } from '../../config/translations';
import { OrderLine } from '../../orders/types';
import { useReturnStore } from '../../store';
import { ReturnInfos, ReturnLine } from '../types';

// Register this component for debug tracking
debug.registerComponent('OrderLineExtras');

type OrderLineExtrasProps = {
  record: ReturnLine & OrderLine & ReturnInfos;
};

const OrderLineExtras = (props: OrderLineExtrasProps) => {
  debug.trackRender('OrderLineExtras');
  const { record } = props;
  // Deliberately not `isGodModeActive()`: that helper requires the *selected*
  // organization to be superadmin, which never holds on this screen — reading a
  // tenant's order switches the current organization to that tenant. The switch
  // would be on and the override still inert. Gate on the console deployment
  // instead, like EurekaRefreshButton does.
  const godMode = useAuth((state) => state.godMode);
  const isSuperAdminConsole = useAuth((state) => state.getIsSuperAdminConsole());
  const isGodModActive = godMode && isSuperAdminConsole;
  const addReturn = useReturnStore((state) => state.addReturn);
  debug.log(
    'OrderLineExtras',
    `Rendering for nart: ${record?.nart}, non_valide: ${record?.non_valide}, godMode: ${isGodModActive}`,
  );
  // TODO replace by the correct evaluation : record?.non_valide === 1

  return record?.non_valide && !isGodModActive ? (
    <Typography.Text>{t('misc.itemNotReturnable')}</Typography.Text>
  ) : (
    <AddReturnLine
      record={record}
      clientId={record?.clientId}
      orderId={record?.orderId}
      onAddReturn={addReturn}
    />
  );
};

export { OrderLineExtras };

// Mark this component as initialized
debug.markInitialized('OrderLineExtras');
